import { Button, Form, Input, Popconfirm, Select } from "antd";
import NoData from "assets/svgs/no_data/NoData";
import { useDiscountCode } from "modules/discount_codes/store";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { CloseButton, Modal} from "react-bootstrap";
import { DeleteOutlined } from "@ant-design/icons";
import CardDiv from "modules/common/card-div/CardDiv";
import { useToast } from "modules/navbar/top/store/toasterStore";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { fourPlaceHolder, typeOptions } from "modules/utilities/utility";

function DiscountCodes() {
  const {
    discountData,
    discountLoading,
    addDiscountLoading,
    fetchDiscountData,
    postDiscountData,
    deleteDiscountData,
  } = useDiscountCode();
  const [form] = Form.useForm();
  const [modalShow, setModalShow] = useState(false);
  const { setToaster } = useToast();
  const [page, newPage] = useState(1);
  const [filterDiscountData, setDiscountFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [sortedDiscountData, setSortedDiscountData] = useState();
  useEffect(() => {
    fetchDiscountData();
  }, []);

  useEffect(() => {
    setSortedDiscountData(discountData);
  }, [discountData]);

  useEffect(() => {
    const numOfSubarrays = Math.max(
      Math.ceil((sortedDiscountData?.length || 0) / 10),
      0
    );
    const paginationArrays = sortedDiscountData
      ? Array.from({ length: numOfSubarrays }, (_, index) => {
          const start = index * 10;
          const end = start + 10;
          return sortedDiscountData?.slice(start, end);
        })
      : [];
    setPageCount(
      Math.max(Math.ceil((sortedDiscountData?.length || 0) / 10), 1)
    );
    setDiscountFilter(paginationArrays[page - 1]);
  }, [sortedDiscountData, page]);

  const handleModalShow = () => {
    setModalShow(!modalShow);
    form.resetFields();
  };

  const onSubmit = async (discountData) => {
    const trimmedData = {};
    for (const key in discountData) {
      trimmedData[key] = discountData[key].trim();
    }
    postDiscountData(
      trimmedData,
      setToaster,
      fetchDiscountData,
      handleModalShow
    );
  };

  const deleteDiscountCode = (id) => {
    deleteDiscountData(id, setToaster, fetchDiscountData);
  };

  const header = ["Code", "Type", "Value", "Created At", "Action"];

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between align-items-center">
            <div className="fs-2">Discount Codes</div>
            <Button
              className="btn btn-primary"
              onClick={() => setModalShow(true)}
            >
              Add Discount
            </Button>
          </div>
        }
        component={
          <div>
            <div className="mt-1 shadow rounded mt-3">
              <div className="d-flex table-head rounded-top">
                {header?.map((discount) => {
                  return (
                    <span className="p-3 py-4 fs-1 fw-bold text-black flex-1 border-end">
                      {discount}
                    </span>
                  );
                })}
              </div>
              {discountLoading ? (
                fourPlaceHolder()
              ) : filterDiscountData && filterDiscountData?.length ? (
                filterDiscountData?.map((discount, discountIndex) => {
                  return (
                    <div
                      className={`d-flex table-row border- border-top-0 ${
                        discountIndex === filterDiscountData?.length - 1 &&
                        `rounded-bottom`
                      }`}
                    >
                      <span className="p-2 fw-bold flex-1 text-break text-black text-wrap border-end">
                        {discount?.discount_code}
                      </span>

                      <span className="p-2 fw-bold flex-1 text-break text-black text-wrap border-end">
                        {discount?.type}
                      </span>
                      <span className="p-2 fw-bold flex-1 text-break text-black text-wrap border-end">
                        {discount?.value}
                      </span>
                      <span className="p-2 fw-bold flex-1 text-break text-black text-wrap border-end">
                        {moment(discount?.created_at).format(
                          "DD MMM YYYY, h:mm a"
                        )}
                      </span>
                      <span className="p-2 fw-bold flex-1 text-break text-black text-wrap border-end">
                        <Popconfirm
                          title={
                            <div>
                              Are you sure to delete
                              <div type="danger">{discount?.discount_code}</div>
                              ?
                            </div>
                          }
                          placement="topRight"
                          onConfirm={() => deleteDiscountCode(discount?.id)}
                        >
                          <Button
                            danger
                            icon={<DeleteOutlined />}
                            type="link"
                          />
                        </Popconfirm>
                      </span>
                    </div>
                  );
                })
              ) : (
                <div className="p-3 bg-white rounded-bottom text-center">
                  No Data Available <NoData />
                </div>
              )}
            </div>
            <PaginationDiv
              paginationData={{ pageCount: pageCount || 1, page: page }}
              newPage={newPage}
            />
          </div>
        }
      />

      <Modal
        show={modalShow}
        onHide={handleModalShow}
        size="md"
        aria-labelledby="contained-modal-title-vtop"
        top
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Create Group
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={handleModalShow}
          />
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form
              form={form}
              layout="vertical"
              name="add_discount_code"
              onFinish={onSubmit}
            >
              <Form.Item
                label="Discount Code"
                name="discount_code"
                rules={[
                  {
                    required: true,
                    message: "Please fill this",
                  },
                  {
                    whitespace: true,
                    message: "Please fill this",
                  },
                ]}
              >
                <Input placeholder="Discount Code" />
              </Form.Item>

              <Form.Item
                label="Type"
                name="type"
                rules={[
                  {
                    required: true,
                    message: "Please fill this",
                  },
                  {
                    whitespace: true,
                    message: "Please fill this",
                  },
                ]}
              >
                <Select allowClear options={typeOptions} placeholder="Type" />
              </Form.Item>

              <Form.Item
                label="Value"
                name="value"
                rules={[
                  {
                    required: true,
                    message: "Please fill this",
                  },
                  {
                    whitespace: true,
                    message: "Please fill this",
                  },
                ]}
              >
                <Input placeholder="Value" />
              </Form.Item>
              <Form.Item style={{ textAlign: "center" }}>
                <Button type="primary" htmlType="submit">
                  Add Code
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleModalShow}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default DiscountCodes;
